import type { FollowType } from '@/utils/following';
import type { LabelProps } from '@/components/raven/ui/Label';

export type FollowButtonProps = {
	className?: string;
	followableId: string;
	followType: FollowType;
	labelProps?: Pick<LabelProps, 'media' | 'text'>;
	variant: FollowButtonVariant;
};

export enum FollowingState {
	// Pre-verification
	Unknown,
	// Logged out
	LoggedOut,
	// Logged In and Not Following
	Naive,
	// Logged In and Not Following
	Inactive,
	// Logged In and Following
	Active,
}

export type FollowButtonVariant = 'horizontal' | 'label' | 'stacked';

export type FollowButtonComponentProps = {
	className?: string;
	followingState: FollowingState;
	id: string;
	labelProps?: Pick<LabelProps, 'media' | 'text'>;
	onClick: () => void;
	variant: FollowButtonVariant;
};
